export const DATADOG_SITE = "datadoghq.com";

export const DATADOG_LOGGING_CLIENT_TOKEN = `pubb199963144c474768326e600b7c7b290`;

export const DATADOG_WEB_SERVICE_NAME = "mem-web-client";
export const DATADOG_WEB_RUM_APPLICATION_ID = "90592b93-feac-4689-aa38-32a3418926cc";
export const DATADOG_WEB_RUM_CLIENT_TOKEN = "pub58b547ac64f60f1daebbd5a79aece916";

export const DATADOG_DESKTOP_SERVICE_NAME = "mem-desktop-client";
export const DATADOG_DESKTOP_RUM_APPLICATION_ID = "74b62791-74e2-4493-9403-cd71f4b6c409";
export const DATADOG_DESKTOP_RUM_CLIENT_TOKEN = "pub70efeb0a1ed2bce2be71c594dd79c502";
